<template>
  <b-container fluid class="p-4">
    <b-row>
      <b-col><h3 class="mb-4">ویرایش کاربر</h3></b-col>
      <b-col class="text-left">
        <router-link :to="{ name: 'User' }">
          <b-button pill variant="primary">لیست کاربران</b-button>
        </router-link>
      </b-col>

    </b-row>
    <profile-component
        :submit="updatePerson"
        :user="person"
        :changeRole="isAdmin"
    />
  </b-container>
</template>

<script>
import {mapGetters} from "vuex";
import ProfileComponent from "../Profile.vue";
import router from "@/router";

export default {
  name: "Update",
  components: {ProfileComponent},
  computed: {
    ...mapGetters({
      isAdmin: "User/isAdmin",
      person: "User/getPerson",
    }),
  },
  methods: {
    updatePerson(form) {
      this.$store.dispatch("User/updatePerson", form);
    },
  },
  async mounted() {
    const personId = router.currentRoute.params.id;
    await this.$store.dispatch("User/getPerson", personId)
  },
};
</script>

<style scoped>
</style>